/**
 * Created by tdunham on 7/7/2017.
 */

export class Player {


	public id: number;              // ID value in the Angular ReST API table.
	public firstname: string;       // First name of the player.
	public surname: string;         // Family name of the player.
  public position: number;        // The ID of the entry in the Angular ReST API 'position' table.
  public status: string;          // Active or inactive
	public team: number;            // The ID of the entry in the Angular ReST API 'team' table.
	public code: string;            // The sport the player is in ('NFL', 'MLB', etc.)
	public college: number;         // The ID of the entry in the Angular ReST API 'college' table.
	public draftyear: number;       // The year the player participated in the NFL draft.

	// The fields below are used when performing Player searches only.

	public position_title: string;  // The position, when it has been looked up and turned into its 'poscode' value.
	public team_title: string;      // The team, when it has been looked up and turned into its 'teamcode' value.
	public college_name: string;    // The college, when it has been looked up and turned into its 'name' value.

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/player/player.ts